var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAgeLevelIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7071 2.90397L6.84818 0.870857C6.6122 0.772214 6.3549 0.772214 6.11892 0.870857L1.27342 2.90397C1.10821 2.97429 0.997559 3.15912 0.997559 3.36805C0.997559 3.57699 1.10821 3.76282 1.27342 3.83193L2.30501 4.26407C2.10065 4.58149 1.95679 4.95035 1.88306 5.34793C1.68592 5.44537 1.54756 5.67439 1.54756 5.93958C1.54756 6.13954 1.6303 6.31105 1.75278 6.42898L1.32601 9.4224C1.298 9.61807 1.42725 9.79688 1.59723 9.79688H2.59789C2.76782 9.79688 2.89712 9.61849 2.86911 9.4226L2.44234 6.42918C2.56489 6.31125 2.64756 6.1224 2.64756 5.93958C2.64756 5.73285 2.55863 5.55727 2.42893 5.43954C2.50201 5.08274 2.65031 4.76009 2.85759 4.4947L6.13353 5.86545C6.36951 5.96409 6.62681 5.96409 6.86279 5.86545L11.7217 3.83233C11.8876 3.76182 11.9976 3.57699 11.9976 3.36805C11.9976 3.15912 11.8876 2.97429 11.7071 2.90397ZM7.03209 6.46996C6.87053 6.54429 6.6849 6.58246 6.49756 6.58246C6.30987 6.58246 6.12476 6.54496 5.94756 6.47086L3.45193 5.42728L3.19756 8.29615C3.19756 9.12587 4.66021 9.79688 6.49756 9.79688C8.30397 9.79688 9.79756 9.12587 9.79756 8.29675L9.54353 5.42588L7.03209 6.46996Z",
    fill: "#364A5E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgeLevelIcon);
export default __webpack_public_path__ + "static/media/ageLevelIcon.5db376a90e087e840e4f15f96948b75e.svg";
export { ForwardRef as ReactComponent };